import { CategoryWithZone } from "@/models/categories.model";
import { EquipmentType, EquipmentTypeDto } from "@/models/equipment.model";
import store from "@/store";
import { UPDATE_SECURITY_EXTRACTOR_ENABLED } from "@/store/operators";
import useVuelidate, { Validation } from "@vuelidate/core";
import { Component, Prop, Vue } from "vue-property-decorator";
import EquipmentDisplay from "./parts/EquipmentDisplay/index.vue";
@Component({
  components: {
    EquipmentDisplay,
  },
  setup() {
    return { v: useVuelidate() };
  },
})
export default class EquipmentCollapse extends Vue {
  @Prop() category!: CategoryWithZone;
  collapseId = "collapse_" + this.category.id;
  visible = false;
  countValueSasDechets = 0;
  applicable =false;
  v!: Validation;
  mounted(): void{
    
      if(this.category.equipmentType == EquipmentType.wastesAirLock && this.category.correspondingZones.length ==0) this.applicable =true
        

}
  //2 way binding from store
  get isSecurityExtractorRequired(): boolean {
    
    return store.state.equipmentsModule.isSecurityExtractorRequired;
  }

  set isSecurityExtractorRequired(newValue: boolean) {
    store.commit(UPDATE_SECURITY_EXTRACTOR_ENABLED, newValue);
  }

  get isExtractorType(): boolean {
    return this.category.equipmentType === EquipmentType.extractor;
  }

  //Hack for ear status
  get isEarType(): boolean {
    return this.category.equipmentType === EquipmentType.ear;
  }

  get isEarMandatory(): boolean {
    return store.state.equipmentsModule.isEarMandatory;
  }
  get isWashesAirLock(): string {
    return EquipmentType.wastesAirLock;
  }

  get isPhone(): boolean {
    return !this.$screen.md;
  }
}
